import { render, staticRenderFns } from "./subToolbar.vue?vue&type=template&id=2bbc045d&"
import script from "./subToolbar.vue?vue&type=script&lang=js&"
export * from "./subToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports